import { calcVwWidth } from "@lib/utils/commonUtility";

export const PRODUCT_CAROUSEL_DEFAULT_SLIDES_PER_VIEW = [1.3, 2.5, 3.5];

export const PRODUCT_CAROUSEL_DEFAULT_TILE_WIDTHS = [
    calcVwWidth(PRODUCT_CAROUSEL_DEFAULT_SLIDES_PER_VIEW[0]),
    calcVwWidth(PRODUCT_CAROUSEL_DEFAULT_SLIDES_PER_VIEW[1]),
    calcVwWidth(PRODUCT_CAROUSEL_DEFAULT_SLIDES_PER_VIEW[1]),
    calcVwWidth(PRODUCT_CAROUSEL_DEFAULT_SLIDES_PER_VIEW[2]),
];
